import { render, staticRenderFns } from "./contentTemplate.vue?vue&type=template&id=4ea5a962&scoped=true"
import script from "./contentTemplate.vue?vue&type=script&lang=js"
export * from "./contentTemplate.vue?vue&type=script&lang=js"
import style0 from "./contentTemplate.vue?vue&type=style&index=0&id=4ea5a962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea5a962",
  null
  
)

export default component.exports